module.exports = __webpack_public_path__ + "img/icon-phone.635ad87.svg";